// Helper function to get brand and discount for tracking
export const getTrackingData = (product, selectedVariation = null) => {
  // Get brand from customFields
  const itemBrand =
    product.customFields?.find(field => field.key === 'merke')?.stringValue ||
    '';

  // Calculate discount amount
  const currentPrice =
    selectedVariation?.price?.incVat || product.price?.incVat || 0;
  const previousPrice =
    selectedVariation?.previousPrice?.incVat ||
    product.previousPrice?.incVat ||
    0;
  const discount =
    previousPrice > currentPrice ? previousPrice - currentPrice : 0;

  return {
    item_brand: itemBrand,
    discount: discount,
    price: currentPrice
  };
};

// Helper function to create tracking item object
export const createTrackingItem = (
  product,
  selectedVariation = null,
  quantity = 1
) => {
  const trackingData = getTrackingData(product, selectedVariation);

  return {
    item_id: selectedVariation?.articleNumber || product.articleNumber,
    item_name: product.name,
    item_brand: trackingData.item_brand,
    price: trackingData.price,
    discount: trackingData.discount,
    quantity: quantity,
    item_category: product.canonicalCategory?.name || ''
  };
};

// Helper function to push enhanced tracking data
export const pushEnhancedTracking = (eventName, currency, value, items) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      currency: currency,
      value: value,
      items: items,
      ecommerce: {
        currency: currency,
        value: value,
        items: items
      }
    });
  }
};
